<template>
  <div class="qianzou" style="background-color: #fff; height: 100%">
    <div style="text-align: center">
      <h1 style="font-size: 20px">{{ title }}</h1>
    </div>
    <div class="c_top" style="background-color: #fff">
      <!-- 投稿须知 -->
      <div name="content" class="content" style="text-align: center">
        <a-textarea
          :read-only="true"
          v-model="shouldKnow"
          :autoSize="{ minRows: 10, maxRows: 20 }"
          style="width: 70%; font-size: 16px; border: none"
        />
      </div>
      <!-- 授权书 -->
      <div
        name="content"
        class="content"
        style="text-align: center; position: relative"
      >
        <a-textarea
          :read-only="true"
          v-model="transferAgreement"
          :autoSize="{ minRows: 10, maxRows: 20 }"
          style="width: 70%; font-size: 16px; border: none"
        ></a-textarea>
        <div
          style="
            margin-top: 12px;
            width: 400px;
            position: relative;
            left: 50%;
            margin-left: -200px;
          "
        >
          <a-button type="primary" @click="downLoad" class="btn3"
            >授权书下载</a-button
          >
          <a-upload
            name="file"
            :fileList="addList"
            :action="serviceAddress"
            :headers="headers"
            :beforeUpload="uploadAddBefore"
            @change="uploadAdd"
            :remove="addRemove"
            :data="data"
            accept=".jpg, .png"
          >
            <a-button type="primary" class="btn3" style="margin-left: 25px">
              上传图片
            </a-button>
          </a-upload>
        </div>
        <div>
          <span style="font-size: 15px; color: red">
            注：请下载PDF文件并打印，手写签字，并拍照上传。
          </span>
        </div>
      </div>
      <!-- 文件上传 -->
      <div name="content" class="content">
        <div style="margin: 15px; width: 500px">
          <label>请上传稿件：</label>
          <a-upload
            name="file"
            :fileList="fileList"
            :action="serviceAddress"
            :headers="headers"
            :beforeUpload="uploadFlieBefore"
            @change="uploadFile"
            :remove="fileRemove"
            :data="data"
            accept=".docx"
          >
            <a-button> <a-icon type="upload" />选择文件 </a-button>
          </a-upload>
        </div>
        <div>
          <span style="font-size: 15px; color: red">
            注：请上传docx格式的word文档。
          </span>
        </div>
      </div>
      <!-- 信息填写 -->
      <div name="content" class="content">
        <a-tabs defaultActiveKey="1">
          <!-- 稿件信息 -->
          <a-tab-pane tab="稿件信息" key="1">
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>标题：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.cnTitle"
                  :maxLength="50"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 副标题： </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.subtitle"
                  :maxLength="50"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>摘要：
              </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.summary"
                  :autoSize="{ minRows: 3, maxRows: 5 }"
                  :maxLength="480"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>关键词：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.keyWords"
                  :maxLength="50"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 课题信息： </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.subjectInfo"
                  :autoSize="{ minRows: 2, maxRows: 2 }"
                  :maxLength="200"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 参考文献： </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.referencesInfo"
                  :autoSize="{ minRows: 4, maxRows: 4 }"
                  :maxLength="380"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>版本：
              </a-col>
              <a-col :span="8">
                <a-select
                  v-model="manuscript.sectionInfo"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeSection"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in sectionInfos"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>
            <a-row class="row" v-if="disciplines.length > 0">
              <a-col :span="3" class="title"> 学科： </a-col>
              <a-col :span="8">
                <a-select
                  v-model="manuscript.discipline"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in disciplines"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>字数：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.wordCount"
                  v-bind:read-only="true"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">备注：</a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.note"
                  :autoSize="{ minRows: 2, maxRows: 2 }"
                  :maxLength="100"
                />
              </a-col>
            </a-row>
          </a-tab-pane>
          <!-- 作者信息 -->
          <a-tab-pane tab="作者信息" key="2" forceRender>
            <a-button class="btn" @click="add">添加</a-button>
            <template>
              <a-table
                :columns="columns"
                :dataSource="authorData"
                :rowKey="(record) => record.authorSort"
                size="small"
              >
                <span slot="corAuthor" slot-scope="text, record">
                  <label v-if="record.corAuthor == 1">是</label>
                  <label v-if="record.corAuthor == 0">否</label>
                </span>
                <span slot="operator" slot-scope="text, record">
                  <a
                    href="javascript:void(0);"
                    @click="() => orderUp(record.authorSort)"
                  >
                    上移
                  </a>
                  <a-divider type="vertical" />
                  <a
                    href="javascript:void(0);"
                    @click="() => orderDown(record.authorSort)"
                  >
                    下移
                  </a>
                  <a-divider type="vertical" />
                  <a
                    href="javascript:void(0);"
                    @click="() => editAuthor(record)"
                  >
                    编辑
                  </a>
                  <a-divider type="vertical" />
                  <a
                    href="javascript:void(0);"
                    @click="() => deleteAuthor(record)"
                  >
                    删除
                  </a>
                </span>
              </a-table>
            </template>
          </a-tab-pane>
          <!-- 银行卡信息 -->
          <a-tab-pane tab="银行卡信息" key="3">
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>开户行：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.openBank"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>开户行号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.bankCode"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>银行卡号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.bankCard"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>身份证号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.idCard"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row" style="margin-left: 100px">
              <a-button type="primary" @click="addBankCard">
                添加银行卡
              </a-button>
              <a-button
                type="primary"
                @click="selectBankCard"
                style="margin-left: 10px"
              >
                选择银行卡
              </a-button>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
      <!-- 信息确认 -->
      <div name="content" class="content">
        <a-tabs defaultActiveKey="1" :activeKey="activeKey" @change="tabChange">
          <!-- 稿件信息 -->
          <a-tab-pane tab="稿件信息" key="1">
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>标题：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.cnTitle"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 副标题： </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.subtitle"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>摘要：
              </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.summary"
                  :autoSize="{ minRows: 2, maxRows: 5 }"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>关键词：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.keyWords"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 课题信息： </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.subjectInfo"
                  :autoSize="{ minRows: 2, maxRows: 5 }"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title"> 参考文献： </a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.referencesInfo"
                  :autoSize="{ minRows: 3, maxRows: 3 }"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>版本：
              </a-col>
              <a-col :span="8">
                <a-select
                  v-model="manuscript.sectionInfo"
                  placeholder="请选择"
                  :disabled="isEnable"
                  style="width: 100%"
                  @change="changeSection"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in sectionInfos"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>
            <a-row class="row" v-if="disciplines.length > 0">
              <a-col :span="3" class="title"> 学科： </a-col>
              <a-col :span="8">
                <a-select
                  v-model="manuscript.discipline"
                  placeholder="请选择"
                  :disabled="isEnable"
                  style="width: 100%"
                >
                  <a-select-option
                    :value="item.dicValue"
                    v-for="item in disciplines"
                    :key="item.dicValue"
                    >{{ item.dicValue }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">
                <span style="color: red">*</span>字数：
              </a-col>
              <a-col :span="8">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="manuscript.wordCount"
                  v-bind:read-only="true"
                  style="width: 100%"
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="3" class="title">备注：</a-col>
              <a-col :span="8">
                <a-textarea
                  placeholder="请输入"
                  class="textarea"
                  v-model="manuscript.note"
                  :autoSize="{ minRows: 1, maxRows: 5 }"
                  v-bind:read-only="isEnable"
                />
              </a-col>
            </a-row>
          </a-tab-pane>
          <!-- 作者信息 -->
          <a-tab-pane tab="作者信息" key="2" forceRender>
            <a-button class="btn isEdit" @click="add">添加</a-button>
            <template>
              <a-table
                :columns="columns"
                :dataSource="authorData"
                :rowKey="(record) => record.authorSort"
                size="small"
              >
                <span slot="corAuthor" slot-scope="text, record">
                  <label v-if="record.corAuthor == 1">是</label>
                  <label v-if="record.corAuthor == 0">否</label>
                </span>
                <span slot="operator" slot-scope="text, record">
                  <div class>
                    <a
                      href="javascript:void(0);"
                      @click="() => orderUp(record.authorSort)"
                      >上移</a
                    >
                    <a-divider type="vertical" />
                    <a
                      href="javascript:void(0);"
                      @click="() => orderDown(record.authorSort)"
                      >下移</a
                    >
                    <a-divider type="vertical" />
                    <a
                      href="javascript:void(0);"
                      @click="() => editAuthor(record)"
                      >编辑</a
                    >
                    <a-divider type="vertical" />
                    <a
                      href="javascript:void(0);"
                      @click="() => deleteAuthor(record)"
                      >删除</a
                    >
                  </div>
                </span>
              </a-table>
            </template>
          </a-tab-pane>
          <!-- 银行卡信息 -->
          <a-tab-pane tab="银行卡信息" key="3">
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>开户行：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.openBank"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>开户行号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.bankCode"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>银行卡号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.bankCard"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="2" class="title">
                <span style="color: red">*</span>身份证号：
              </a-col>
              <a-col :span="4">
                <a-input
                  placeholder="请输入"
                  class="input"
                  v-model="bankCard.idCard"
                  readOnly
                />
              </a-col>
            </a-row>
            <a-row class="row" v-if="!isEnable">
              <a-button type="primary" @click="addBankCard">
                添加银行卡
              </a-button>
              <a-button
                type="primary"
                @click="selectBankCard"
                style="margin-left: 10px"
              >
                选择银行卡
              </a-button>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div
      class="btn_bottom"
      style="padding-bottom: 10px; background-color: #fff"
    >
      <a-button id="refuse" name="btn" class="btn2" @click="refuse">
        不同意
      </a-button>
      <a-button id="agree" name="btn" class="btn btn2" @click="agree"
        >同意</a-button
      >
      <a-button id="previous" name="btn" class="btn" @click="previous">
        上一步
      </a-button>
      <a-button id="ignore" name="btn" class="btn" @click="ignore">
        跳过
      </a-button>
      <a-button id="previous" name="btn" class="btn" @click="previous">
        上一步
      </a-button>
      <a-button id="next" name="btn" class="btn" @click="next">下一步</a-button>
      <a-button id="editBtn" name="btn" class="btn" @click="editBtn">
        修改
      </a-button>
      <a-button id="submit" name="btn" class="btn" @click="submit">
        完成
      </a-button>
      <a-button id="cancel" name="btn" class="btn" @click="cancel('noSave')">
        取消
      </a-button>
      <a-button id="save" name="btn" class="btn" @click="cancel('save')">
        保存
      </a-button>
    </div>
    <a-modal
      :title="modelTitle"
      v-model="visible"
      :centered="true"
      width="600px"
      @ok="authorSubmit"
      :maskClosable="false"
    >
      <template>
        <div>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>作者姓名：
            </a-col>
            <a-col :span="8">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.authorName"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">通讯作者：</a-col>
            <a-col :span="8">
              <a-switch :checked="isCorAuthor" @change="isCor" />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>性别：
            </a-col>
            <a-col :span="8">
              <a-radio-group v-model="value" @change="sexChange">
                <a-radio :value="1">男</a-radio>
                <a-radio :value="0">女</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>出生年月：
            </a-col>
            <a-col :span="8">
              <a-month-picker :value="date" @change="dateChange" />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title"> 职称： </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.professionalTitle"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title"> 研究方向： </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.studyDirection"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>
              所在省市：
            </a-col>
            <a-col :span="16">
              <a-select
                v-model="authorInfo.province"
                style="width: 180px"
                @change="handleProvinceChange"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="val in provinces"
                  :value="val.name"
                  :key="val.name"
                >
                  {{ val.name }}
                </a-select-option>
              </a-select>
              <a-select
                v-model="authorInfo.city"
                style="width: 180px"
                placeholder="请选择"
                @change="onCityChange"
              >
                <a-select-option
                  v-for="item in cities"
                  :value="item.name"
                  :key="item.name"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>
              邮政编码：
            </a-col>
            <a-col :span="8">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.postCode"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>单位名称：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.companyName"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>单位地址：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.companyAddress"
              />
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>联系电话：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.phone"
              />
            </a-col>
            <a-col
              :span="12"
              class="note"
              style="color: #ff0000; font-size: 12px; margin-left: 90px"
              >*该联系电话将作为接收收稿、采用等通知的手机号</a-col
            >
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="title">
              <span style="color: red">*</span>email：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="authorInfo.email"
              />
            </a-col>
            <a-col
              :span="12"
              class="note"
              style="color: #ff0000; font-size: 12px; margin-left: 90px"
              >*该邮箱将作为接收收稿、采用等通知的邮件地址</a-col
            >
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="提示框"
      v-model="delVisible"
      @ok="deleteOk"
      :centered="true"
      :maskClosable="false"
    >
      <p>确认删除吗？</p>
    </a-modal>
    <!-- 添加银行卡 -->
    <a-modal
      title="添加银行卡"
      v-model="bankCardVisible"
      width="600px"
      @ok="bankCardSubmit"
      :centered="true"
      :maskClosable="false"
    >
      <a-row class="row">
        <a-col :span="6" class="title">
          <span style="color: red">*</span>开户行：
        </a-col>
        <a-col :span="14">
          <a-input
            placeholder="请输入"
            class="input"
            v-model="newBankCard.openBank"
          />
        </a-col>
      </a-row>
      <a-row class="row">
        <a-col :span="6" class="title">
          <span style="color: red">*</span>开户行号：
        </a-col>
        <a-col :span="14">
          <a-input
            placeholder="请输入"
            class="input"
            v-model="newBankCard.bankCode"
          />
        </a-col>
      </a-row>
      <a-row class="row">
        <a-col :span="6" class="title">
          <span style="color: red">*</span>银行卡号：
        </a-col>
        <a-col :span="14">
          <a-input
            placeholder="请输入"
            class="input"
            v-model="newBankCard.bankCard"
          />
        </a-col>
      </a-row>
      <a-row class="row">
        <a-col :span="6" class="title">
          <span style="color: red">*</span>身份证号：
        </a-col>
        <a-col :span="14">
          <a-input
            placeholder="请输入"
            class="input"
            v-model="newBankCard.idCard"
          />
        </a-col>
      </a-row>
      <a-row class="row">
        <a-col :span="6" class="title"> 默认账号： </a-col>
        <a-col :span="14">
          <a-switch v-model="newBankCard.isDefault" />
        </a-col>
      </a-row>
    </a-modal>
    <!-- 选择银行卡 -->
    <a-modal
      title="选择银行卡"
      v-model="selectCardVisible"
      width="600px"
      @ok="selectCardSubmit"
      :centered="true"
      :maskClosable="false"
    >
      <a-table
        rowKey="id"
        size="small"
        bordered
        :columns="selectCardColumns"
        :data-source="authorBankCards"
        :rowSelection="{
          type: 'radio',
          onChange: (selectedRowKeys, selectedRows) => {
            manuscript.bankCardId = selectedRowKeys[0];
          },
        }"
      >
      </a-table>
    </a-modal>
  </div>
</template>

<script>
const viewAuthorColumns = [
  {
    title: "作者顺序",
    dataIndex: "sort",
    width: 110,
  },
  {
    title: "通讯作者",
    dataIndex: "corAuthor",
    width: 110,
    scopedSlots: { customRender: "corAuthor" },
  },
  {
    title: "姓名",
    dataIndex: "authorName",
    width: 120,
  },
  // {
  //   title: '职称',
  //   width: '10%',
  //   dataIndex: 'professionalTitle',
  //   key: 'professionalTitle'
  // },
  // {
  //   title: '研究方向',
  //   width: '10%',
  //   dataIndex: 'studyDirection',
  //   key: 'studyDirection'
  // },
  {
    title: "单位名称",
    dataIndex: "companyName",
  },
  {
    title: "单位地址",
    dataIndex: "companyAddress",
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    width: 150,
  },
  {
    title: "Email",
    dataIndex: "email",
  },
];

const updateAuthorColumns = [
  {
    title: "作者顺序",
    dataIndex: "sort",
    width: 110,
  },
  {
    title: "通讯作者",
    dataIndex: "corAuthor",
    width: 100,
    scopedSlots: { customRender: "corAuthor" },
  },
  {
    title: "姓名",
    dataIndex: "authorName",
    width: 120,
  },
  // {
  //   title: '职称',
  //   width: '6%',
  //   dataIndex: 'professionalTitle',
  //   key: 'professionalTitle'
  // },
  // {
  //   title: '研究方向',
  //   width: '10%',
  //   dataIndex: 'studyDirection',
  //   key: 'studyDirection'
  // },
  {
    title: "单位名称",
    dataIndex: "companyName",
  },
  {
    title: "单位地址",
    dataIndex: "companyAddress",
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    width: 150,
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "操作",
    width: 220,
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];
import qs from "qs";
import moment from "moment";
import cityData from "../../../assets/js/city.js";
export default {
  name: "Contribute",
  inject: ["reload", "appReload"],
  data() {
    return {
      provinces: cityData,
      cities: [],
      serviceAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "manuscripts",
      },
      fileList: [],
      addList: [],
      index: 0,
      activeKey: "1",
      title: "投稿须知",
      shouldKnow: "",
      transferAgreement: "",
      transferFile: "",
      submitMessage:
        "提交成功，已收到来稿，编辑团队将尽快处理您的稿件，请耐心等待。",
      //稿件信息
      delVisible: false,
      manuscript: {
        cnTitle: "",
        subtitle: "",
        summary: "",
        keyWords: "",
        subjectInfo: "",
        referencesInfo: "",
        wordCount: "",
        note: "",
        sectionInfo: "",
        discipline: "",
      },
      authorSort: 1,
      isCorAuthor: true,
      authorInfo: {
        authorName: "",
        companyName: "",
        professionalTitle: "", //职称
        studyDirection: "", //研究方向
        province: "",
        city: "",
        postCode: "",
        birth: "",
        companyAddress: "",
        phone: "",
        email: "",
        corAuthor: 1,
        eduLevel: "0",
        code: "1",
        sex: 1,
      },
      authorBankCards: [],
      authorData: [],
      date: null,
      bankCard: {
        id: 0,
        openBank: "",
        bankCode: "",
        bankCard: "",
        idCard: "",
        isDefault: true,
      },
      sectionInfos: [],
      disciplines: [],
      modelTitle: "",
      visible: false,
      columns: [],
      filePath: "",
      value: 1,
      isEnable: true,
      authorDataOld: [],
      manuscriptOld: {},
      bankCardOld: {},
      bankCardVisible: false,
      selectCardVisible: false,
      newBankCard: {
        id: 0,
        openBank: "",
        bankCode: "",
        bankCard: "",
        idCard: "",
        isDefault: false,
      },
      selectCardColumns: [
        {
          title: "开户行",
          dataIndex: "openBank",
          key: "openBank",
        },
        {
          title: "开户行号",
          dataIndex: "bankCode",
          key: "bankCode",
        },
        {
          title: "银行卡号",
          dataIndex: "bankCard",
          key: "bankCard",
        },
        {
          title: "身份证号",
          dataIndex: "idCard",
          key: "idCard",
        },
      ],
    };
  },
  created() {
    this.columns = updateAuthorColumns;
    this.axios.get("/manuscriptTemplate/queryTemplate").then((res) => {
      if (res.data.code == "OK") {
        this.shouldKnow = res.data.data.shouldKnow;
        this.transferAgreement = res.data.data.transferAgreement;
        this.transferFile = res.data.data.transferFile;
        this.submitMessage = res.data.data.submitMessage;
      } else {
        this.utils.messageInfo(this, "error", "查询投稿须知失败！");
      }
    });

    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
    // this.axios
    //   .get("/dataDic/queryChild", { params: { parentCode: "discipline" } })
    //   .then((res) => {
    //     if (res.data) {
    //       this.disciplines = res.data;
    //     } else {
    //       this.utils.messageInfo(this, "error", "查询刊物学科失败！");
    //     }
    //   });

    this.axios
      .get("/manuscriptsAuthor/queryByUserCode", {
        params: {
          userCode: sessionStorage.getItem("userCode"),
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data.code == "OK") {
          var author = res.data.data;
          this.authorInfo.authorName = author.authorName;
          this.authorInfo.sex = author.sex;
          this.authorInfo.birth = author.birth;
          this.authorInfo.eduLevel = author.eduLevel;
          this.authorInfo.companyName = author.companyName;
          this.authorInfo.province = author.province;
          this.authorInfo.city = author.city;
          this.authorInfo.postCode = author.postCode;
          this.authorInfo.professionalTitle = author.professionalTitle;
          this.authorInfo.studyDirection = author.studyDirection;
          this.authorInfo.companyAddress = author.companyAddress;
          this.authorInfo.phone = author.phone;
          this.authorInfo.email = author.email;
          this.authorInfo.sort = "第" + this.authorSort + "作者";
          this.authorInfo.authorSort = this.authorSort;
          this.authorInfo.corAuthor = 1;
          this.authorData.push(this.authorInfo);
          this.authorSort += 1;
        } else {
          this.utils.messageInfo(this, "error", "查询作者信息失败！");
        }
      });

    this.axios
      .get("/author/getAuthorBankCard", {
        params: {
          authorCode: sessionStorage.getItem("userCode"),
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data.code == "OK") {
          this.authorBankCards = res.data.data;
          if (this.authorBankCards && this.authorBankCards.length > 0) {
            var cardInfo = this.authorBankCards.find(
              (item) => item.isDefault == 1
            );
            if (cardInfo) {
              this.bankCard.id = cardInfo.id;
              this.bankCard.openBank = cardInfo.openBank;
              this.bankCard.bankCode = cardInfo.bankCode;
              this.bankCard.bankCard = cardInfo.bankCard;
              this.bankCard.idCard = cardInfo.idCard;
              this.bankCard.isDefault = cardInfo.isDefault == 1;
              this.manuscript.bankCardId = cardInfo.id;
            }
          }
        } else {
          this.utils.messageInfo(this, "error", "查询作者信息失败！");
        }
      });
  },
  mounted() {
    var gaojian = sessionStorage.getItem("gaojian");
    if (gaojian) {
      this.fileList = JSON.parse(gaojian);
    }
    var gaojianInfo = sessionStorage.getItem("gaojianInfo");
    if (gaojianInfo) {
      this.manuscript = JSON.parse(gaojianInfo);
    }
    var shouquan = sessionStorage.getItem("shouquan");
    if (shouquan) {
      this.addList = JSON.parse(shouquan);
    }
    this.$nextTick(() => {
      document.getElementsByName("content")[0].style.display = "block";
    });
  },
  methods: {
    changeSection(val) {
      let code = this.sectionInfos.find((item) => item.dicValue == val).dicCode;
      this.axios
        .get("/sectionDisciplineRel/listSectionDisciplineRel", {
          params: { sectionCode: code },
        })
        .then((res) => {
          this.disciplines = [];
          if (res.data.data) {
            res.data.data.forEach((item) => {
              this.disciplines.push({
                dicCode: item.disciplineCode,
                dicValue: item.disciplineName,
              });
            });
          } else {
            this.utils.messageInfo(this, "error", "查询刊物学科失败！");
          }
        });
      this.manuscript.discipline = "";
    },
    addBankCard() {
      this.bankCardVisible = true;
    },
    bankCardSubmit() {
      this.bankCard = { ...this.newBankCard };
      this.newBankCard = {
        id: 0,
        openBank: "",
        bankCode: "",
        bankCard: "",
        idCard: "",
        isDefault: false,
      };
      this.manuscript.bankCardId = 0;
      this.bankCardVisible = false;
    },
    selectBankCard() {
      this.selectCardVisible = true;
    },
    selectCardSubmit() {
      var findCard = this.authorBankCards.find(
        (item) => item.id == this.manuscript.bankCardId
      );
      this.bankCard = { ...findCard };
      this.selectCardVisible = false;
    },
    handleProvinceChange(value) {
      this.cities = cityData.find((item) => item.name == value).children;
      this.authorInfo.city = this.cities[0].name;
    },
    onCityChange(val) {
      this.authorInfo.city = val;
      this.$forceUpdate();
    },
    downLoad() {
      var pdfUrl = this.$config.serviceAddress + this.transferFile;
      this.axios.get(pdfUrl, { responseType: "blob" }).then((res) => {
        if (res.data) {
          var blob = new Blob([res.data], { type: "application/pdf" });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "授权书.pdf";
          link.click();
        }
      });
    },
    uploadFlieBefore(file) {
      let acceptTypeList = [".docx"];
      let fileSuffix = file.name.substring(file.name.lastIndexOf("."));
      const acceptWithType = acceptTypeList.indexOf(fileSuffix) > -1;
      if (!acceptWithType) {
        this.$message.error("请上传指定格式的文档");
      }
      return acceptWithType;
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
      }
      if (info.file.status === "done") {
        this.manuscript.wordCount = info.file.response.data.wordCount;
        sessionStorage.setItem("gaojian", JSON.stringify(this.fileList));
        sessionStorage.setItem("gaojianInfo", JSON.stringify(this.manuscript));
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    tabChange(key) {
      this.activeKey = key;
    },
    uploadAddBefore(file) {
      let acceptTypeList = ["image/jpeg", "image/png"];
      let fileType = file.type;
      const acceptWithType = acceptTypeList.indexOf(fileType) > -1;
      if (!acceptWithType) {
        this.$message.error("请上传指定格式的图片");
      }
      return acceptWithType;
    },
    uploadAdd(info) {
      this.addList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.addList = fileList;
      if (info.file.status !== "uploading") {
        this.addList = info.fileList;
      }
      if (info.file.status === "done") {
        sessionStorage.setItem("shouquan", JSON.stringify(this.addList));
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove(file) {
      this.fileList = [];
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
        sessionStorage.removeItem("gaojian");
        sessionStorage.removeItem("gaojianInfo");
      }
    },
    addRemove(file) {
      this.addList = [];
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
        sessionStorage.removeItem("shouquan");
      }
    },
    previous() {
      if (this.index == 4) {
        this.columns = updateAuthorColumns;
      }
      this.index -= 1;
      this.title = btnClick(this.index);
    },
    next() {
      if (this.index == 2) {
        var checkFileList = [];
        for (var i = 0; i < this.fileList.length; i++) {
          if (
            this.fileList[i].response &&
            this.fileList[i].response.code == "OK"
          ) {
            checkFileList.push(this.fileList[i].response.data);
          }
        }

        if (checkFileList.length == 0) {
          this.utils.messageInfo(this, "error", "请上传稿件！");
          return;
        } else {
          this.manuscript.cnTitle = checkFileList[0].fileName;
        }
      } else if (this.index == 3) {
        if (this.manuscript.cnTitle == "" || this.manuscript.cnTitle == null) {
          this.utils.messageInfo(this, "error", "标题不能为空！");
          return;
        }
        // if (
        //   this.manuscript.subtitle == "" ||
        //   this.manuscript.subtitle == null
        // ) {
        //   this.utils.messageInfo(this, "error", "副标题不能为空！");
        //   return;
        // }
        if (this.manuscript.summary == "" || this.manuscript.summary == null) {
          this.utils.messageInfo(this, "error", "摘要不能为空！");
          return;
        }
        if (
          this.manuscript.keyWords == "" ||
          this.manuscript.keyWords == null
        ) {
          this.utils.messageInfo(this, "error", "关键词不能为空！");
          return;
        }
        if (
          this.manuscript.sectionInfo == "" ||
          this.manuscript.sectionInfo == null
        ) {
          this.utils.messageInfo(this, "error", "版本不能为空！");
          return;
        }
        if (
          (this.manuscript.sectionInfo == "小学课程版（A）" ||
            this.manuscript.sectionInfo == "中学课程版（B）") &&
          this.manuscript.discipline == ""
        ) {
          this.utils.messageInfo(this, "error", "学科不能为空！");
          return;
        }
        // if (
        //   this.manuscript.subjectInfo == "" ||
        //   this.manuscript.subjectInfo == null
        // ) {
        //   this.utils.messageInfo(this, "error", "课题信息不能为空！");
        //   return;
        // }
        // if (
        //   this.manuscript.discipline == "" ||
        //   this.manuscript.discipline == null
        // ) {
        //   this.utils.messageInfo(this, "error", "学科不能为空！");
        //   return;
        // }
        if (this.bankCard.openBank == "" || this.bankCard.openBank == null) {
          this.utils.messageInfo(
            this,
            "error",
            "银行卡信息未完善，开户行不能为空！"
          );
          return;
        }
        if (this.bankCard.bankCode == "" || this.bankCard.bankCode == null) {
          this.utils.messageInfo(
            this,
            "error",
            "银行卡信息未完善，开户行号不能为空！"
          );
          return;
        }
        if (this.bankCard.bankCard == "" || this.bankCard.bankCard == null) {
          this.utils.messageInfo(
            this,
            "error",
            "银行卡信息未完善，银行卡号不能为空！"
          );
          return;
        }
        if (this.bankCard.idCard == "" || this.bankCard.idCard == null) {
          this.utils.messageInfo(
            this,
            "error",
            "银行卡信息未完善，身份证号不能为空！"
          );
          return;
        }
        var findCard = this.authorBankCards.filter(
          (item) =>
            item.bankCard == this.bankCard.bankCard && this.bankCard.id == 0
        );
        if (findCard && findCard.length > 0) {
          this.utils.messageInfo(
            this,
            "error",
            "银行卡信息错误，银行卡号已存在！"
          );
        }
      } else if (this.index == 4) {
        this.columns = viewAuthorColumns;
      }
      this.index += 1;
      this.title = btnClick(this.index);
    },
    refuse() {
      this.index -= 1;
      this.title = btnClick(this.index);
    },
    agree() {
      if (this.index == 1) {
        var checkFileList = [];
        for (var i = 0; i < this.addList.length; i++) {
          if (
            this.addList[i].response &&
            this.addList[i].response.code == "OK"
          ) {
            checkFileList.push(this.addList[i].response.data);
          }
        }

        if (checkFileList.length == 0) {
          this.utils.messageInfo(this, "error", "请上传授权书！");
          return;
        }
      }
      this.index += 1;
      this.title = btnClick(this.index);
    },
    ignore() {
      if (this.index == 4) {
        this.columns = viewAuthorColumns;
      }
      this.index += 1;
      this.title = btnClick(this.index);
    },
    editBtn() {
      this.columns = updateAuthorColumns;
      document.getElementById("previous").style.display = "none";
      document.getElementById("editBtn").style.display = "none";
      document.getElementById("submit").style.display = "none";
      document.getElementById("cancel").style.display = "block";
      document.getElementById("save").style.display = "block";
      this.isEnable = false;
      var isEdit = document.getElementsByClassName("isEdit");
      for (var i = 0; i < isEdit.length; i++) {
        isEdit[i].style.display = "block";
      }

      this.authorDataOld = [];
      for (var j = 0; j < this.authorData.length; j++) {
        this.authorDataOld.push(this.authorData[j]);
      }

      this.manuscriptOld = {
        cnTitle: this.manuscript.cnTitle,
        wordCount: this.manuscript.wordCount,
        bankCardId: this.manuscript.bankCardId,
        subtitle: this.manuscript.subtitle,
        summary: this.manuscript.summary,
        keyWords: this.manuscript.keyWords,
        subjectInfo: this.manuscript.subjectInfo,
        referencesInfo: this.manuscript.referencesInfo,
        note: this.manuscript.note,
        sectionInfo: this.manuscript.sectionInfo,
        discipline: this.manuscript.discipline,
      };

      this.bankCardOld = {
        openBank: this.bankCard.openBank,
        bankCode: this.bankCard.bankCode,
        bankCard: this.bankCard.bankCard,
        idCard: this.bankCard.idCard,
      };
    },
    cancel(type) {
      if (type == "noSave") {
        this.authorData = [];
        for (var i = 0; i < this.authorDataOld.length; i++) {
          this.authorData.push(this.authorDataOld[i]);
        }

        this.manuscript = {
          cnTitle: this.manuscriptOld.cnTitle,
          wordCount: this.manuscriptOld.wordCount,
          note: this.manuscriptOld.note,
          bankCardId: this.manuscriptOld.bankCardId,
          subtitle: this.manuscriptOld.subtitle,
          summary: this.manuscriptOld.summary,
          keyWords: this.manuscriptOld.keyWords,
          subjectInfo: this.manuscriptOld.subjectInfo,
          referencesInfo: this.manuscriptOld.referencesInfo,
          sectionInfo: this.manuscriptOld.sectionInfo,
          discipline: this.manuscriptOld.discipline,
        };

        this.bankCard = {
          openBank: this.bankCardOld.openBank,
          bankCode: this.bankCardOld.bankCode,
          bankCard: this.bankCardOld.bankCard,
          idCard: this.bankCardOld.idCard,
        };
      }
      this.columns = viewAuthorColumns;
      document.getElementById("previous").style.display = "block";
      document.getElementById("editBtn").style.display = "block";
      document.getElementById("submit").style.display = "block";
      document.getElementById("cancel").style.display = "none";
      document.getElementById("save").style.display = "none";
      this.isEnable = true;
      var isEdit = document.getElementsByClassName("isEdit");
      for (var j = 0; j < isEdit.length; j++) {
        isEdit[j].style.display = "none";
      }
    },
    submit() {
      if (this.authorData.length == 0) {
        this.utils.messageInfo(this, "error", "请添加作者信息！");
        this.activeKey = "2";
        return;
      }
      if (this.manuscript.cnTitle == "") {
        this.utils.messageInfo(this, "error", "中文标题不能为空！");
        this.activeKey = "1";
        return;
      }
      // if (this.manuscript.subtitle == "") {
      //   this.utils.messageInfo(this, "error", "副标题不能为空！");
      //   this.activeKey = "1";
      //   return;
      // }
      if (this.manuscript.summary == "") {
        this.utils.messageInfo(this, "error", "摘要不能为空！");
        this.activeKey = "1";
        return;
      }
      if (this.manuscript.keyWords == "") {
        this.utils.messageInfo(this, "error", "关键词不能为空！");
        this.activeKey = "1";
        return;
      }
      // if (this.manuscript.subjectInfo == "") {
      //   this.utils.messageInfo(this, "error", "课题信息不能为空！");
      //   this.activeKey = "1";
      //   return;
      // }
      if (this.manuscript.sectionInfo == "") {
        this.utils.messageInfo(this, "error", "版本不能为空！");
        this.activeKey = "1";
        return;
      }
      if (
        (this.manuscript.sectionInfo == "小学课程版（A）" ||
          this.manuscript.sectionInfo == "中学课程版（B）") &&
        this.manuscript.discipline == ""
      ) {
        this.utils.messageInfo(this, "error", "学科不能为空！");
        this.activeKey = "1";
        return;
      }
      // if (this.manuscript.discipline == "") {
      //   this.utils.messageInfo(this, "error", "学科不能为空！");
      //   this.activeKey = "1";
      //   return;
      // }
      if (this.bankCard.openBank == "") {
        this.utils.messageInfo(this, "error", "开户行不能为空！");
        this.activeKey = "3";
        return;
      }
      if (this.bankCard.bankCode == "") {
        this.utils.messageInfo(this, "error", "开户行号不能为空！");
        this.activeKey = "3";
        return;
      }
      if (this.bankCard.bankCard == "") {
        this.utils.messageInfo(this, "error", "银行卡号不能为空！");
        this.activeKey = "3";
        return;
      }
      if (this.bankCard.idCard == "") {
        this.utils.messageInfo(this, "error", "身份证号不能为空！");
        this.activeKey = "3";
        return;
      }
      let array = [];
      for (let i = 0; i < this.authorData.length; i++) {
        if (this.authorData[i].corAuthor === 1) {
          array.push(this.authorData[i].corAuthor);
        }
      }
      if (array.length === 0) {
        this.utils.messageInfo(this, "warning", "请至少选择一个通讯作者！");
        return false;
      }

      //附件
      var fileList = [];
      var addList = [];
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.code == "OK") {
          fileList.push(this.fileList[i].response.data);
        }
      }

      for (var j = 0; j < this.addList.length; j++) {
        if (this.addList[j].response.code == "OK") {
          addList.push(this.addList[j].response.data);
        }
      }

      this.axios
        .post("/manuscripts/saveManuscripts", {
          //稿件信息
          cnTitle: this.manuscript.cnTitle,
          wordCount: this.manuscript.wordCount,
          note: this.manuscript.note,
          authorCode: sessionStorage.getItem("userCode"),
          bankCardId: this.manuscript.bankCardId,
          subtitle: this.manuscript.subtitle,
          summary: this.manuscript.summary,
          keyWords: this.manuscript.keyWords,
          subjectInfo: this.manuscript.subjectInfo,
          referencesInfo: this.manuscript.referencesInfo,
          sectionInfo: this.manuscript.sectionInfo,
          discipline: this.manuscript.discipline,

          //附件信息
          fileList: JSON.stringify(fileList),
          addList: JSON.stringify(addList),

          //稿件作者信息
          authorData: JSON.stringify(this.authorData),

          //银行卡信息
          openBank: this.bankCard.openBank,
          bankCode: this.bankCard.bankCode,
          bankCard: this.bankCard.bankCard,
          idCard: this.bankCard.idCard,
          isDefault: this.bankCard.isDefault ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", this.submitMessage);
            sessionStorage.setItem("selectedKeys", "1002");
            sessionStorage.setItem("currentMenu", "稿件管理>>我的稿件");
            sessionStorage.removeItem("gaojian");
            sessionStorage.removeItem("gaojianInfo");
            sessionStorage.removeItem("shouquan");
            this.$router.push({ path: "/author/myManuscript" });
            this.appReload();
          } else {
            this.utils.messageInfo(this, "error", "保存稿件信息失败！");
          }
        });
    },
    isCor(checked) {
      if (checked) {
        this.authorInfo.corAuthor = 1;
        this.isCorAuthor = true;
      } else {
        this.authorInfo.corAuthor = 0;
        this.isCorAuthor = false;
      }
    },
    sexChange(e) {
      this.authorInfo.sex = e.target.value;
    },
    dateChange(date, dateString) {
      this.date = date;
      this.authorInfo.birth = dateString;
    },
    authorSubmit() {
      if (this.authorInfo.authorName === "") {
        this.utils.messageInfo(this, "error", "作者姓名不能为空！");
        return;
      } else if (this.authorInfo.sex === "") {
        this.utils.messageInfo(this, "error", "作者性别不能为空！");
        return;
      } else if (this.authorInfo.birth === undefined) {
        this.utils.messageInfo(this, "error", "作者出生年月不能为空！");
        return;
      } else if (
        this.authorInfo.province === "" ||
        this.authorInfo.city === ""
      ) {
        this.utils.messageInfo(this, "error", "所在省市不能为空！");
        return;
      } else if (this.authorInfo.postCode === "") {
        this.utils.messageInfo(this, "error", "邮政编码不能为空！");
        return;
      } else if (this.authorInfo.companyName === "") {
        this.utils.messageInfo(this, "error", "单位名称不能为空！");
        return;
      } else if (this.authorInfo.companyAddress === "") {
        this.utils.messageInfo(this, "error", "单位地址不能为空！");
        return;
      } else if (this.authorInfo.phone === "") {
        this.utils.messageInfo(this, "error", "联系电话不能为空！");
        return;
      } else if (this.authorInfo.email === "") {
        this.utils.messageInfo(this, "error", "Email不能为空！");
        return;
      }
      if (!this.utils.isPhone(this.authorInfo.phone)) {
        this.utils.messageInfo(this, "error", "手机号格式不正确！");
        return;
      }
      if (!this.utils.isEmail(this.authorInfo.email)) {
        this.utils.messageInfo(this, "error", "邮箱格式不正确！");
        return;
      }
      if (this.oprateType == "add") {
        this.authorInfo.sort = "第" + this.authorSort + "作者";
        this.authorInfo.authorSort = this.authorSort;
        this.authorData.push(this.authorInfo);
        this.authorSort += 1;
      } else if (this.oprateType == "edit") {
        for (var i = 0; i < this.authorData.length; i++) {
          if (this.authorData[i].authorSort == this.authorInfo.authorSort) {
            this.authorData.splice(i, 1, this.authorInfo);
          }
        }

        var tmpData = this.authorData;
        this.authorData = [];
        this.authorData = tmpData;
      }
      this.visible = false;
    },
    deleteAuthor(authorInfo) {
      this.delVisible = true;
      this.authorInfo = authorInfo;
    },
    deleteOk() {
      this.delVisible = false;
      for (var i = 0; i < this.authorData.length; i++) {
        if (this.authorData[i].authorSort == this.authorInfo.authorSort) {
          this.authorData.splice(i, 1);
        }
      }
      this.authorSort = 1;
      for (var j = 0; j < this.authorData.length; j++) {
        this.authorData[j].sort = "第" + this.authorSort + "作者";
        this.authorData[j].authorSort = this.authorSort;
        this.authorSort += 1;
      }
    },
    add() {
      this.authorInfo = {
        authorName: "",
        companyName: "",
        professionalTitle: "", //职称
        studyDirection: "", //研究方向
        province: "",
        city: "",
        postCode: "",
        companyAddress: "",
        phone: "",
        email: "",
        corAuthor: 1,
        eduLevel: "0",
        code: "",
        sex: 1,
      };
      this.date = null;
      this.value = 1;
      this.isCorAuthor = true;
      this.modelTitle = "新增";
      this.visible = true;
      this.oprateType = "add";
    },
    orderUp(authorSort) {
      if (authorSort != 1) {
        var data = this.authorData[authorSort - 1];
        data.sort = "第" + (authorSort - 1) + "作者";
        data.authorSort = authorSort - 1;
        var perData = this.authorData[authorSort - 2];
        perData.sort = "第" + authorSort + "作者";
        perData.authorSort = authorSort;
        this.authorData.splice(authorSort - 1, 1, perData);
        this.authorData.splice(authorSort - 2, 1, data);
      }
    },
    orderDown(authorSort) {
      if (authorSort != this.authorSort - 1) {
        var data = this.authorData[authorSort - 1];
        data.sort = "第" + (authorSort + 1) + "作者";
        data.authorSort = authorSort + 1;
        var nextData = this.authorData[authorSort];
        nextData.sort = "第" + authorSort + "作者";
        nextData.authorSort = authorSort;
        this.authorData.splice(authorSort - 1, 1, nextData);
        this.authorData.splice(authorSort, 1, data);
      }
    },
    editAuthor(authorInfo) {
      this.date = null;
      var birth = authorInfo.birth;
      if (birth != undefined && birth != "") {
        this.date = moment(birth, "YYYY-MM");
      }
      this.authorInfo = {
        sort: authorInfo.sort,
        sex: authorInfo.sex,
        birth: authorInfo.birth,
        authorSort: authorInfo.authorSort,
        corAuthor: authorInfo.corAuthor,
        authorName: authorInfo.authorName,
        professionalTitle: authorInfo.professionalTitle,
        studyDirection: authorInfo.studyDirection,
        province: authorInfo.province,
        city: authorInfo.city,
        postCode: authorInfo.postCode,
        eduLevel: authorInfo.eduLevel,
        companyName: authorInfo.companyName,
        companyAddress: authorInfo.companyAddress,
        phone: authorInfo.phone,
        email: authorInfo.email,
      };
      if (authorInfo.corAuthor == 1) {
        this.isCorAuthor = true;
      } else {
        this.isCorAuthor = false;
      }
      this.value = this.authorInfo.sex;
      this.modelTitle = "编辑";
      this.visible = true;
      this.oprateType = "edit";
    },
  },
};
function btnClick(index) {
  var title = "";
  //切换显示按钮
  var btn = document.getElementsByName("btn");
  for (var i = 0; i < btn.length; i++) {
    btn[i].style.display = "none";
  }
  if (index == 0) {
    title = "投稿须知";
    document.getElementById("next").style.display = "block";
  } else if (index == 1) {
    title = "授权书";
    document.getElementById("refuse").style.display = "block";
    document.getElementById("agree").style.display = "block";
  } else if (index == 2) {
    title = "稿件上传";
    document.getElementById("previous").style.display = "block";
    document.getElementById("next").style.display = "block";
  } else if (index == 3) {
    title = "稿件信息";
    document.getElementById("previous").style.display = "block";
    document.getElementById("next").style.display = "block";
  } else if (index == 4) {
    title = "稿件确认";
    document.getElementById("previous").style.display = "block";
    document.getElementById("editBtn").style.display = "block";
    document.getElementById("submit").style.display = "block";
  } else if (index == 5) {
    title = "稿件确认";
    document.getElementById("previous").style.display = "block";
    document.getElementById("editBtn").style.display = "block";
    document.getElementById("submit").style.display = "block";
  }
  //切换content内容
  var div = document.getElementsByName("content");
  for (var j = 0; j < div.length; j++) {
    if (index == j) {
      div[j].style.display = "block";
    } else {
      div[j].style.display = "none";
    }
  }
  return title;
}
</script>

<style scoped>
li {
  list-style: none;
}
.btn_bottom {
  text-align: center;
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.btn_bottom .btn {
  color: #ffffff;
  border-color: #1890ff;
  background-color: #1890ff;
  /*margin-top:360px;*/
  margin-left: 20px;
  display: none;
}
.btn2 {
  color: #1890ff;
  border-color: #1890ff;
  /*background-color: #1890ff;*/
  /*margin-top:360px;*/
  margin-left: 20px;
  display: none;
  width: 80px;
}
.btn3 {
  width: 100px;
}
.btn_bottom #next {
  display: block;
}
.content {
  min-height: 430px;
  margin-top: 32px;
  font-size: 16px;
  display: none;
}
.content .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
#submit {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}
.row {
  margin-bottom: 20px;
}
.row .title {
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.isEdit {
  display: none;
}
</style>
